import { registerHubSection } from '@/guidance';

import { useTipsBadgeCount, useTipsSectionVisible } from './api';
import { GUIDE_TITLE } from './copy';
import { GuideHubSection } from './guide-hub-section';

/**
 * Side-effect module, imported once from `main.tsx`: registers «پیشنهادها» as
 * the first section of the «راهنما و پیشنهادها» hub.
 *
 * At import time, not in an effect, so the hub and the Help entry see the same
 * set of sections on every render and call the section hooks in a stable
 * order. `order: 10` (below 100) places it above the tour's «شروع کار».
 *
 * The guide has no header button of its own: the tour's «راهنما» carries the
 * dot and the count (`useBadgeCount`), and because that entry is on every
 * screen, it is also what warms the tips list before the dashboard asks.
 */
export const unregisterGuideHubSection = registerHubSection({
  key: 'tips',
  order: 10,
  title: GUIDE_TITLE,
  Component: GuideHubSection,
  useVisible: useTipsSectionVisible,
  useBadgeCount: useTipsBadgeCount,
});
